import React, { Component } from 'react';
import { Row, Col } from 'react-flexbox-grid';
import Review from './Review/Review'
import Feature from './Feature/Feature'
import Fade from 'react-reveal/Fade';
import Map from './Map/Map'

import './landing-styles.css'
import './landing-form-styles.css'

import ReactGA from 'react-ga';
ReactGA.initialize('UA-110112779-1');
ReactGA.pageview(window.location.pathname + window.location.search);

class Landing extends Component {

  constructor(props) {
    super(props)
    this.state = { h: "h" }


    window.addEventListener('scroll', this.handleScroll.bind(this));

  }

  handleScroll(e) {

    var headingContainer = this.refs.headingContainer
    var headingContainerMultiplier = 0.2
    this.addParallaxToElement(headingContainer, headingContainerMultiplier)

    // var landingPhone = this.refs.phoneImage
    // var landingPhoneMultiplier = 0.3
    // this.addParallaxToElement(landingPhone, landingPhoneMultiplier)


  }

  addParallaxToElement(element, multiplier) {
    var scrolltop = window.pageYOffset
    element.style.top = -scrolltop * multiplier + 'px'
    element.style.backgroundPositionY = -scrolltop * multiplier + 'px'
  }

  render() {
    return (
      <div>
        <Fade>
          <div className='landing-image' ref='phoneImage'>
            <Row center='xs' middle='xs' id='heading-row'>
              <Col lg={24} md={12} sm={24} xs={24}>
                <div id='heading-container' ref='headingContainer'>
                  <Fade top cascade delay={500}>
                    <Row center='xs' middle='xs'>
                      <Col>
                        <img alt='logo' width='150pt' height='150pt' src={require('./images/logo.png')}/>
                      </Col>
                    </Row>
                    <h1 className='gradientH1 landing-heading' id='landing-heading'>UniversityGO</h1>
                    <h3 id="landing-subheading">University maps that lead students in the right direction.</h3>
                    <p id="landing-p"><a href='mailto:contact@universitygo.co?subject=University%20Request%20'>Contact us </a> to get your university on board.</p>
                    <a className='app-store-button' href="https://itunes.apple.com/app/apple-store/id891199335?pt=239255&ct=landing-cta&mt=8"> </a>
                  </Fade>
                </div>
              </Col>
            </Row>
          </div>
        </Fade>

        <Row center='xs' top='xs' id='review-section'>
          <Col xs={12}>
            <h1 className='gradientH1'>Trusted by Thousands of Students</h1>
            <p id='review-subheading'>Tens of thousands of students have used UniversityGO for a better university experience. Read what some of users have to say: </p>
          </Col>
          <Review reviewTitle="Simple app, incredibly useful" reviewText="I wish I had found this app sooner in the semester. I can see [UniversityGO] helping so many people find their classes!" author={"CactusWrecked"} delay={100} />
          <Review reviewTitle="A must get app for freshmen" reviewText="This app has been a life saver to me! I am a freshamn attending [ASU] and with this campus being enormous, trying to find my classes during the first couple weeks was nearly impossible." author={"Ajlee20"} delay={200} />
          <Review reviewTitle="Help me!" reviewText="I love this app! Super easy to navigate the app and its usage on campus. It's great for visitors and current students to help get around campus which can be confusing at times." author={"dgfjb"} delay={300} />
          <Review reviewTitle="I love this app" reviewText="This is going to help me so much! So easy to use and way more efficent than other [...] apps." author={"almost asu student"} delay={400} />
          <Review reviewTitle="Easy to use and a huge time saver" reviewText="ASU is a massive campus, and every semester I find myself in new buildings. [UniversityGO] makes it 100x easier to get the the right building quickly." author={"Hpriniski"} delay={500} />
          <Col xs={12}>
            <p>Want to leave a review or read more? Check out UniversityGO on the <a href='https://itunes.apple.com/app/apple-store/id891199335?pt=239255&ct=web-review-section&mt=8'>App Store.</a></p>
          </Col>
        </Row>
        <Map />
        <Row center='xs' top='xs' id='feature-section'>
          <Col xs={12}>
            <h1 className='gradientH1'>Designed to Stay Out of Your Way</h1>
            <p>UniversityGO packs features that are useful when you need them most.</p>
          </Col>
        </Row>

        <Feature headingText='Campus in Your Pocket' description='Finding your way around campus is hard, but UniversityGO makes campus navigation easy. Just select your university and you are good to go.' image='map-image' />
        <Feature headingText='Add Your Classes and Schedule' description='No more going to the clunky university website to quickly reference your schedule.' image='my-classes-image' stagger={true} />
        <Feature headingText='On Time Every Time' description='Just started the semester? Stayed up too late last night? ETAs can tell you how long it will take to get to class. You can also get directions directly to where you need to go.' image='building-info-image' />
        <Feature headingText='Quick Search' description='Quickly search for any place on campus by name or a more obscure building code.' image='search-list-image' stagger={true} />

        

      </div>
    )
  }
}

export default Landing;



// WEBPACK FOOTER //
// ./src/Views/Landing/Landing.js